"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Underline = exports.Tag = exports.Strong = exports.P = void 0;
var _typography = require("../tokens/typography");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _color = require("../tokens/color");
var _get2 = _interopRequireDefault(require("lodash-es/get"));
//p, span, bold,strong,pre,code,small,Label
// eslint-disable-next-line no-unused-vars
var Text = function Text(_) {
  return "";
};
var getTextSize = function getTextSize(props) {
  return (0, _get2["default"])(props, "size", "inherit");
};
var getTextColor = function getTextColor(props) {
  return (0, _get2["default"])(props, "color", _color.grey.z900);
};
var getTextMargin = function getTextMargin(props) {
  return (0, _get2["default"])(props, "margin", 0);
};
var getTextLineHeight = function getTextLineHeight(props) {
  return (0, _get2["default"])(_typography.lineHeight, "".concat(props.lineHeight), _typography.lineHeight.medium);
};
Text.p = _styledComponents["default"].p.withConfig({
  componentId: "sc-1hez2tp-0"
})(["font-size:", ";line-height:", ";margin:", " 0;color:", ";"], getTextSize, getTextLineHeight, getTextMargin, getTextColor);
Text.strong = _styledComponents["default"].strong.withConfig({
  componentId: "sc-1hez2tp-1"
})(["line-height:", ";font-weight:", ";color:", ";font-size:inherit;"], _typography.lineHeight.medium, _typography.fontWeights.medium, _color.grey.z800);
Text.underline = _styledComponents["default"].span.withConfig({
  componentId: "sc-1hez2tp-2"
})(["color:", ";font-size:inherit;text-decoration:underline;"], _color.grey.z800);
Text.Tag = _styledComponents["default"].a.withConfig({
  componentId: "sc-1hez2tp-3"
})(["display:inline;font-size:24px;line-height:28px;color:", ";cursor:pointer;margin:0;text-transform:capitalize;&:hover{color:", ";}"], _color.red.z400, _color.red.z500);
Text.LargeP = _styledComponents["default"].p.withConfig({
  componentId: "sc-1hez2tp-4"
})(["font-size:24px;line-height:28px;margin:", " 0;color:", ";"], _typography.fontSizes.z300, _color.grey.z900);
var P = exports.P = Text.p;
var Strong = exports.Strong = Text.strong;
var Underline = exports.Underline = Text.underline;
var Tag = exports.Tag = Text.Tag;
var _default = exports["default"] = Text;